import './index.less';
import { useEffect, useState } from 'react';

export default function CountDown({ count }) {
  const [value, setValue] = useState(count);
  useEffect(() => {
    const interval = setInterval(() => {
      setValue((v) => {
        if (v === 1) {
          clearInterval(interval);
          return v;
        }
        return v - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="record-count-down">
      <div className="text">{value}</div>
    </div>
  );
}
